import Vue from 'vue'
import maskDirective from 'vue-the-mask/src/directive'
import tokens from 'vue-the-mask/src/tokens'

tokens.N = { pattern: /[0-9a-zA-Z]/, transform: v => v.toLocaleUpperCase() }

Vue.directive('mask', maskDirective)

export default Vue
